import { TCCEligibilityCheckAction } from "../actions/TCCEligibilityCheckAction";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';


const initEligibilityCheck = {
    requestBody: {
        sectionId: "TCCEligibilityCheck",
        steps: [
            {
                sequence: "0",
                stepId: "TCCEligibilityCheck",
                offerContainerId: "",
                fields: [
                    {
                        name: "IDNumber",
                        value: ""
                    },
                    {
                        name: "",
                        value: ""
                    },
                    {
                        name: "Mobilycustomer",
                        value: ""
                    },
                    {
                        name: "ContactPhoneNumber",
                        value: ""
                    },
                    {
                        name: "Email",
                        value: ""
                    },
                    {
                        name: "OTPType",
                        value: ""
                    },
                    {
                        name: "ActiveVoiceLines",
                        value: ""
                    },
                    {
                        name: "CustomerRelatedAccountResponse",
                        value: ""
                    },
                    {
                        name: "NationalityISOCode",
                        value: ""
                    },
                    {
                        name: "FECEncrypted",
                        value: ""
                    },
                    {
                        name: "NewStack",
                        value: "N"
                    },
                    {
                        name: "CustomerConsent",
                        value: ""
                    },
                    {
                        name: "OTP",
                        value: ""
                    }
                ],
                options: [
                    {
                        name: "IDName",
                        value: ""
                    }
                ]
            }
        ]
    },

    tccEligibilityResponse: {

    },
    customerRelatedAccountResponse: {

    },
    nationalityCode: "",
    eSimValidationResponse:{

    },
    eligibilitySendOtpResponse:{},
    eligibilityValidateOtpResponse:{},
    eligibilityResendOtpResponse:{}
}

const EligibilityCheckReducer = (state: any = initEligibilityCheck, action: any) => {
    const { type } = action;
    const { payload } = action;
    var tccValue = { ...state.requestBody.steps };
    switch (type) {
        case TCCEligibilityCheckAction.TCC_ELIGIBILITY_CHECK_SUCCESS:
            tccValue[0].fields[0].value = payload?.personId;
            tccValue[0].fields[1].name = payload?.nationalityFieldName;
            tccValue[0].fields[1].value = payload?.nationalityName;
            tccValue[0].options[0].value = payload?.idType === "1" ? "Saudi National ID" : "IQAMA";
            state.nationalityCode = payload?.nationality;
            tccValue[0].fields[3].value = payload?.contactPhone;
            tccValue[0].fields[8].value = payload?.nationality;
            tccValue[0].fields[10].value = payload?.response?.data?.NewStack ? payload.response?.data?.NewStack : "N";
            tccValue[0].fields[11].value = payload?.customerConsent === true ? "true" : "";
            return { ...state, tccEligibilityResponse: payload?.response };

        case TCCEligibilityCheckAction.CUSTOMER_RELATED_ACCOUNT_SUCCESS:

            return { ...state, customerRelatedAccountResponse: payload?.response };

        case TCCEligibilityCheckAction.ESIM_VALIDATION_SUCCESS:

            return { ...state, eSimValidationResponse: payload?.response };

        case TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_INITIATE_SUCCESS:

            return { ...state, eligibilitySendOtpResponse: payload };

        case TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_VALIDATE_SUCCESS:

            return { ...state, eligibilityValidateOtpResponse: payload };

        case TCCEligibilityCheckAction.TCC_ELIGIBILITY_CEM_OTP_RSEND_SUCCESS:

            return { ...state, eligibilityResendOtpResponse: payload };

        case TCCEligibilityCheckAction.STORE_CUSTOMER_DETAILS:
            let mobilycustomer = payload?.customerRelatedAccountResponse?.MobilyCustomer ? payload.customerRelatedAccountResponse.MobilyCustomer : "";
            let email = payload?.customerRelatedAccountResponse?.customer?.account?.[0]?.email ? payload.customerRelatedAccountResponse.customer?.account?.[0].email : "";
            let otpType = payload?.customerRelatedAccountResponse?.OTPDetails?.OTPType ? payload.customerRelatedAccountResponse.OTPDetails.OTPType : "";
            let otpVoiceLines = payload?.customerRelatedAccountResponse?.customer?.activeVoiceLines ? payload.customerRelatedAccountResponse.customer.activeVoiceLines : "";
            let fecEncrypted = otpType ?? (otpType.toUpperCase() === 'MOBILY' ? '0' : '1');
            tccValue[0].fields[2].value = mobilycustomer;
            tccValue[0].fields[4].value =email;
            tccValue[0].fields[5].value = otpType;
            tccValue[0].fields[6].value = otpVoiceLines ? JSON.stringify(otpVoiceLines) : "";
            tccValue[0].fields[7].value = payload?.customerRelatedAccountResponse ? JSON.stringify(payload.customerRelatedAccountResponse) : "";
            tccValue[0].fields[9].value = fecEncrypted;
            tccValue[0].offerContainerId = payload?.offerContainerId;
            tccValue[0].fields[10].value = payload?.newStackVal ? payload.newStackVal : 'N';
            tccValue[0].fields[12].value = payload?.otpVal;
            return state;

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, tccEligibilityResponse: {}, customerRelatedAccountResponse: {}, 
            eSimValidationResponse: {}, eligibilitySendOtpResponse: {}, eligibilityValidateOtpResponse: {}, eligibilityResendOtpResponse: {} };

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'TCCEligibilityCheck')
            });
            if (section.length > 0) {
                tccValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                for (let i = 0; i < tccValue[0].options.length; i++) {
                     const tccValueField = section[0].steps[0].options.filter((field: any) => { return (field.name === tccValue[0].options[i].name) })[0];
                     tccValue[0].options[i].value = tccValueField ? tccValueField.value : "";
                }

                for (let i = 0; i < tccValue[0].fields.length; i++) {
                    const tccValueField = section[0].steps[0].fields.filter((field: any) => { return (field.name === tccValue[0].fields[i].name) })[0];
                    tccValue[0].fields[i].value = tccValueField ? tccValueField.value : "";
               }
               tccValue[0].fields[1].name = section[0].steps[0].fields[1].name;
               tccValue[0].fields[1].value = section[0].steps[0].fields[1].value;
            }
            return state;

        default:
            return state;
    }
};

export default EligibilityCheckReducer;